import { useEffect, useState } from "react";
import { toast } from "sonner";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "@/components/ui/dialog";
import { api, errMsg } from "@/lib/api";
import { periodLabel, rupiah } from "@/lib/format";

export function PaidCorrectDialog({ target, onClose, onDone }) {
  const [paid, setPaid] = useState("");
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  useEffect(() => {
    if (target) { setPaid(String(target.paid || 0)); setReason(""); }
  }, [target]);
  if (!target) return null;
  const n = Number(paid);
  const valid = paid !== "" && n >= 0 && n <= target.due && n !== (target.paid || 0) && reason.trim().length >= 5;
  const submit = async () => {
    setBusy(true);
    try {
      await api.put("/payments/correct", { customer_id: target.customer_id, period: target.period, paid: n, reason: reason.trim() });
      toast.success(`Keterangan bayar ${target.customer_name} dikoreksi menjadi ${rupiah(n)}`);
      onClose();
      onDone?.();
    } catch (e) { toast.error(errMsg(e)); } finally { setBusy(false); }
  };
  return (
    <Dialog open={!!target} onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-md" data-testid="paid-correct-dialog">
        <DialogHeader>
          <DialogTitle>Koreksi Keterangan Bayar</DialogTitle>
          <DialogDescription>{target.customer_name} · Periode {periodLabel(target.period)} · hanya saat DRAFT</DialogDescription>
        </DialogHeader>
        <div className="grid grid-cols-2 gap-2 text-center text-xs">
          <div className="border rounded-sm p-2"><div className="text-slate-500">Tagihan</div><div className="font-mono font-semibold">{rupiah(target.due)}</div></div>
          <div className="border rounded-sm p-2"><div className="text-slate-500">Dibayar saat ini</div><div className="font-mono font-semibold">{rupiah(target.paid || 0)}</div></div>
        </div>
        <div className="space-y-3">
          <div>
            <Label className="text-xs">Jumlah dibayar yang benar (Rp)</Label>
            <div className="flex gap-2">
              <Input type="number" min={0} max={target.due} value={paid} onChange={(e) => setPaid(e.target.value)} className="font-mono" data-testid="paid-correct-amount-input" />
              <Button type="button" variant="outline" onClick={() => setPaid(String(target.due))} data-testid="paid-correct-full-btn">Lunas</Button>
              <Button type="button" variant="outline" onClick={() => setPaid("0")} data-testid="paid-correct-zero-btn">Belum</Button>
            </div>
          </div>
          <div><Label className="text-xs">Alasan koreksi (wajib, min. 5 huruf)</Label><Input value={reason} onChange={(e) => setReason(e.target.value)} placeholder="cth: salah input nominal" data-testid="paid-correct-reason-input" /></div>
          <p className="text-[11px] text-slate-500">Koreksi dicatat sebagai entri "koreksi" di riwayat pembayaran dan audit log; riwayat lama tidak dihapus.</p>
        </div>
        <div className="flex justify-end">
          <Button disabled={busy || !valid} onClick={submit} className="bg-emerald-700 hover:bg-emerald-800" data-testid="paid-correct-submit-btn">Simpan Koreksi</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
